import ListIterator from "./ListIterator";
import ListNode from "./ListNode";

export default class List {
    constructor() {
        this._startNode = null;
        this._endNode = null;
        this._numNodes = 0;
    };

    size() {
        return this._numNodes;
    };

    /**
     * Returns the first element in the list or null if there is no 
     * @returns {*}
     */
    first() {
        if (this._startNode) {
            return this._startNode.data;
        }
        return null;
    };

    push(data) {
        var node = new ListNode(data);
        if (this._startNode == null) {
            this._startNode = node;
            this._endNode = node;
        } else {
            node.previous = this._endNode;
            this._endNode.next = node;
            this._endNode = node;
        }
        this._numNodes++;

        return data;
    };

    unshift(data) {
        var node = new ListNode(data);
        if (this._startNode == null) {
            this._startNode = node;
            this._endNode = node;
        } else {
            node.next = this._startNode;
            this._startNode.previous = node;
            this._startNode = node;
        }
        this._numNodes++;
        return data;
    };

    contains(data) {
        return (this.getNode(data) != null);
    };

    insertAfter(dataToInsert, data) {

        var node = this.getNode(data);
        var newNode;
        if (node != null) {
            newNode = new ListNode(dataToInsert);
            newNode.previous = node;
            newNode.next = node.next;
            if (node.next != null) {
                node.next.previous = newNode;
            }
            node.next = newNode;
            if (this._endNode == node) {
                this._endNode = newNode;
            }
            this._numNodes++;
        }

        return (newNode == null ? null : dataToInsert);
    };

    insertBefore(dataToInsert, data) {
        var node = this.getNode(data);

        if (node != null) {
            newNode = new ListNode(dataToInsert);
            newNode.previous = node.previous;
            newNode.next = node;
            if (node.previous != null) {
                node.previous.next = newNode;
            }
            node.previous = newNode;
            if (this._startNode == node) {
                this._startNode = newNode;
            }
            this.numNodes++;
        }
        return (newNode == null) ? null : dataToInsert;
    };

    remove(data) {

        var result = null;

        var node = this.getNode(data);
        if (node != null) {
            result = node.data;
            this.removeNode(node);
        }
        return result;
    };

    shift() {
        var result;
        if (this._startNode == null) {
            result = null;
        }
        else {
            result = this._startNode.data;
            this.removeNode(this._startNode);
        }
        return result;
    };

    pop() {
        var result;
        if (this._endNode == null) {
            result = null;
        }
        else {
            result = this._endNode.data;
            this.removeNode(this._endNode);
        }
        return result;
    };

    clear() {
        var node;
        var nextNode;

        if (this._startNode != null) {
            node = this._startNode;
            while (node != null) {
                nextNode = node.next;
                node.next = null;
                node.previous = null;
                node = nextNode;
            }
        }
        this._startNode = null;
        this._endNode = null;
        this._numNodes = 0;
    };

    isEmpty() {
        //FIXME: fixed in javascript not in actionscript yet
        return (this._startNode === null || this._startNode === undefined);
    };

    toArray() {
        var result = [];
        var node;
        if (this._startNode != null) {
            node = this._startNode;
            while (node != null) {
                result.push(node.data);
                node = node.next;
            }
        }
        return result;
    };

    getIterator() {
        return new ListIterator(this._startNode);
    };

    getNode(data) {
        var node;
        var result;

        if (this._startNode != null) {
            node = this._startNode;
            while (node != null) {
                if (node.data == data) {
                    result = node;
                    break;
                }
                node = node.next;
            }
        }
        return result;
    };

    removeNode(node) {
        if (this._startNode == node) {
            this._startNode = node.next;
        }
        if (this._endNode == node) {
            this._endNode = node.previous;
        }
        if (node.previous != null) {
            node.previous.next = node.next;
        }
        if (node.next != null) {
            node.next.previous = node.previous;
        }
        node.previous = null;
        node.next = null;
        this._numNodes--;
    };
}